export default __webpack_public_path__ + "static/media/EuclidCircularA-Light.5949ca0c.ttf";